/* unplugin-vue-components disabled */import { render } from "./mongo.vue?vue&type=template&id=a4f3bd1e&scoped=true"
import script from "./mongo.vue?vue&type=script&setup=true&lang=js"
export * from "./mongo.vue?vue&type=script&setup=true&lang=js"

import "./mongo.vue?vue&type=style&index=0&id=a4f3bd1e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4f3bd1e"],['__file',"src/pages/settings/admin/mongo/mongo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a4f3bd1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a4f3bd1e', __exports__)) {
    api.reload('a4f3bd1e', __exports__)
  }
  
  module.hot.accept("./mongo.vue?vue&type=template&id=a4f3bd1e&scoped=true", () => {
    api.rerender('a4f3bd1e', render)
  })

}


export default __exports__